import React, { useState } from "react";
import toast from "react-hot-toast";
import { FiBell } from "react-icons/fi";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const SendNotification = () => {
  const [formData, setFormData] = useState({ title: "", description: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.description) {
      toast.error("Please fill in both fields");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/announcement/send-notification`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ title: formData.title, description: formData.description }),
      });
      const result = await res.json();
      if (res.ok) {
        toast.success(result.message || "Notification sent!");
        setFormData({ title: "", description: "" });
      } else {
        toast.error(result.message || "Failed to send");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
          <FiBell size={15} className="text-blue-600" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-800">Send Notification</h3>
          <p className="text-xs text-gray-400">Broadcast to all users</p>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Title</label>
          <input
            name="title"
            type="text"
            placeholder="Notification title"
            className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
            value={formData.title}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Description</label>
          <textarea
            name="description"
            placeholder="Notification message"
            className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 resize-none"
            rows={3}
            value={formData.description}
            onChange={handleChange}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-medium py-2.5 rounded-lg transition"
        >
          {loading ? "Sending..." : "Send to All Users"}
        </button>
      </form>
    </div>
  );
};

export default SendNotification;
